<template>
  <div class="container">
    <!--    <Breadcrumbs-->
    <!--      :breadcrumbs="breadcrumbs"-->
    <!--    />-->

    <div class="catalog-head">
      <h1 class="catalog-head__label">{{ pageTitle }}</h1>
    </div>

    <div
      class="catalog__grids"
      :class="{
        '--collection': Boolean(catalogType === 'collection'),
        '--product': Boolean(catalogType === 'product'),
      }"
    >
      <template v-if="!isProductsLoading || products.length > 0">
        <template
          v-for="(product, idx) in products"
          :key="`collection-catalog-product-${idx}`"
        >
          <!-- Карточка коллекции -->
          <CollectionCard
            v-if="Boolean(idx <= (products.length - 1)) && product.isProductSet"
            :product="product"
            :page="Boolean(pagination) ? pagination.currentPage : ''"
          />

          <!-- Карточка товара -->
          <CatalogProductCard
            v-if="Boolean(idx <= (products.length - 1)) && !product.isProductSet"
            :product="product"
            :page="Boolean(pagination) ? pagination.currentPage : ''"
          />
        </template>
      </template>
      <template v-if="isProductsLoading">
        <ProductCardLoad />
        <ProductCardLoad />
        <ProductCardLoad />
        <ProductCardLoad />
        <ProductCardLoad />
        <ProductCardLoad />
      </template>
    </div>

    <!-- Если нет товаров -->
    <div
      v-if="isEmptyProducts"
      class="empty-content"
    >
      <span>Таких товаров не нашлось</span>
    </div>


    <template v-if="isVisiblePagination">
      <div class="catalog-pagination"/>
      <Pagination
        :current-page="Number.parseFloat(String(state.page || 0))"
        :total-pages="Number.parseFloat(String(pagination.pageCount || 0))"
        :is-show-more="Boolean(catalogType === 'product')"
        @change="onChangePage"
        @loadMore="onLoadMore"
      />
    </template>

    <!--  Полное описание  -->
    <!--    <div-->
    <!--      v-if="pageFullDescriotion"-->
    <!--      class="catalog-footer__description"-->
    <!--    >-->
    <!--      <span v-html="pageFullDescriotion" />-->
    <!--    </div>-->
  </div>
</template>

<script setup lang="ts">
import useCategory from '#sitis/composables/useSitisCategory';
import ProductCardLoad from '~/components/catalog/ProductCardLoad.vue';
import useEcommerce from '~/composables/useEcommerceYandex';
import type {ComputedRef} from "vue";
import {scrollToElement} from "~/utils/scrollToElement";

const { addEcommerceProductsList } = useEcommerce();
const Pagination = defineAsyncComponent(() => import('~/components/UI/Pagination.vue'));
const CollectionCard = defineAsyncComponent(() => import('~/components/catalog/CollectionCard.vue'));
const CatalogProductCard = defineAsyncComponent(() => import('~/components/catalog/CatalogProductCard.vue'));

const {
  state,
  products,
  category,
  filterInfo,
  pagination,
  filterPages: apiFilterPages,

  getCategory,
  getProducts,
  getFilterInfo,
  changeCurrentPage,
  onClearProductsList,
  loadMoreProducts,
} = useCategory({
  extensions: ['short_characteristics'],
  defaultPerPage: 21
});

const $route = useRoute();
const {
  data,
  clear,
  refresh,
  pending,
} = await useLazyAsyncData(`category-init--${$route.path}--id`, async () => await Promise.all([
  await getCategory().then((res) => res),
  await getProducts().then((res) => res),
  await getFilterInfo().then((res) => res)
]));

await initCategories();
async function initCategories () {
  clear();
  await refresh({ _initial: true, dedupe: 'cancel' });
  if (data.value && !pending.value) {
    return;
  }
  throw createError({
    statusCode: 404,
    statusMessage: 'Page Not Found'
  });
}

const catalogType = computed(() => (products.value?.[0]?.isProductSet
  ? 'collection'
  : 'product'));
const onChangePage = async (newPage: number) => {
  scrollToElement('.catalog__grids');
  onClearProductsList();
  await changeCurrentPage(newPage);
};
const onLoadMore = async (newPage: number) => {
  await loadMoreProducts();
};

const isProductsLoading = computed(() => state.value.isLoadProducts);
const isEmptyProducts = computed(() => Boolean(
  pagination.value.pageCount <= 0 &&
    !state.value.isLoadProducts
));

const isVisiblePagination: ComputedRef<boolean> = computed(() => {
  return Boolean(pagination.value.pageCount > 1)
});

const pageTitle = computed(() => filterInfo?.value?.h1 || category?.value?.dynamicFields?.alt_title || category?.value?.title || category?.value?.name || category?.value?.title || '');
const {
  setSEOTitles
} = useSitisCMSPage();
function initSeoMeta () {
  const currentPage = pagination.value.currentPage || 1;

  let title = apiFilterPages?.[0]?.seo?.title || filterInfo?.seo_title || category.value?.seo?.title || category.value?.metaTitle || category.value?.title || '';
  if (title && currentPage > 1) {
    title = `${title} страница ${currentPage}`;
  }

  let description = apiFilterPages?.[0]?.seo?.description || filterInfo?.seo_description || category.value?.seo?.description || category.value?.metaDescription || '';
  if (currentPage > 1) {
    description = `${description} страница ${currentPage}`;
  }

  const keywords = apiFilterPages?.[0]?.seo?.keywords || category.value?.seo?.keywords || category.value?.metaKeywords || '';

  setSEOTitles({
    seoTitle: title,
    seoDescription: description,
    seoKeywords: keywords
  });
};
initSeoMeta();

onMounted(() => {
  addEcommerceProductsList(products.value);
});
</script>

<style scoped lang="scss">
.catalog-head {
  display: flex;
  flex-direction: column;
  margin-bottom: 54px;
  justify-content: center;
}

.catalog-head__label {
  font-weight: 700;
  font-size: 48px;
  color: #000;
  margin-top: 10px;
}

.catalog-head__description {
  margin-top: 12px;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  font-feature-settings: 'tnum' on, 'lnum' on;
  color: #000;
}

.catalog__controls {
  display: flex;
  flex-direction: column;
  margin-bottom: 28px;
}

.catalog-footer__description {
  margin-top: 50px;
  margin-bottom: 70px;
  font-weight: 500;
  font-size: 22px;
  line-height: 30px;
  text-align: center;
  font-feature-settings: 'tnum' on, 'lnum' on;
  color: #000;
}

.catalog__grids {
  display: flex;
  flex-wrap: wrap;

  &.--product {
    margin-left: -20px;

    & > * {
      width: calc(100% / 3 - 20px);
      margin-left: 20px;
    }
  }

  &.--collection {
    & > * {
      width: 100%;
      margin-bottom: 18px;
    }
  }
}

.empty-content {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 90px;
  box-sizing: border-box;
}

.empty-content span {
  font-size: 36px;
  line-height: 43px;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #000;
  opacity: 0.6;
}

.load-more-prev {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  background: #fff;
  border: 1px solid var(--primary);
  box-sizing: border-box;
  border-radius: 4px;
  margin-bottom: 15px;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  z-index: 10;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0.02em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: var(--primary);

  &:hover {
    box-shadow: 0 1px 2px rgb(0 0 0 / 20%);
  }
}

.catalog-pagination {
  margin-top: 32px;
}

@media screen and (max-width: 990px) {
  .catalog-head__label {
    font-size: 18px;
    line-height: 32px;
    margin-bottom: 10px;
    margin-top: 0;
    font-weight: 400;
    padding: 0 8px;
  }

  .catalog-breadcumbs {
    margin-top: 0;
    margin-bottom: 0;
  }

  .catalog__grids {
    &.--product {
      & > * {
        width: calc(100% / 2 - 20px);
        margin-left: 20px;
      }
    }

    &.--collection {
      & > * {
        width: 100%;
        margin-bottom: 3px;
      }
    }
  }
}

@media screen and (max-width: 760px) {
  .catalog-head {
    margin-bottom: 15px;
  }

  .catalog-head__description {
    margin-top: 2px;
    font-size: 14px;
    line-height: 16px;
  }

  .catalog__controls {
    margin-bottom: 20px;
  }

  .catalog__controls-head {
    background-color: #F4F4F4;
    margin: 0 -15px;
    width: auto;
    padding: 12px 15px;
  }

  .catalog-footer__description {
    font-size: 18px;
    line-height: 24px;
    margin-top: 20px;
    margin-bottom: 30px;
  }

}

@media screen and (max-width: 590px) {
  .catalog__grids {
    margin-left: 0;

    &.--product {
      & > * {
        width: calc(100%);
      }
    }
  }
}
</style>
